module.exports = __webpack_public_path__ + "img/Logistic.c781608b.svg";